import axios from "axios";
import AuthController from "../controllers/auth";
export const BASE_URL = import.meta.env.VITE_BASE_URL;

export const apiClient = axios.create({
  baseURL: BASE_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const persistData = AuthController.getPersistedCredentials();

    if (persistData?.token) {
      config.headers[`Authorization`] = persistData.token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) =>
    response?.data?.error?.message === "jwt expired"
      ? AuthController.logout()
      : response,
  (error) => {
    return Promise.reject(error);
  }
);
